import BaseDialog from "@/components/BaseDialog";

// 批量选择 弹窗
export function batchChooseModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./batchChooseModal.vue'),
        options: {
            width: '520px',
            title: '批量选择',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 账户详情 弹窗
export function accountDetailModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./accountDetailModal.vue'),
        options: {
            width: '800px',
            title: props.title||'账户详情',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}

// KPI校验-计划多产品 弹窗
export function kpiPlanAppModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./kpiPlanAppModal.vue'),
        options: {
            width: '800px',
            title: '详情',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}

// KPI校验-计划无产品 弹窗
export function kpiNoAppModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./kpiNoAppModal.vue'),
        options: {
            width: '800px',
            title: '详情',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}


/**
 * 温馨提示
 * @param {*} param0
 * @returns
 */
export function messageTipModal({ cbs, props }) {
    return new BaseDialog({
        component: ()=>import('./messageTipModal'),
        options: {
            width: '500px',
            title: '温馨提示',
            'close-on-press-escape': false,
            'close-on-click-modal': false,
            'show-close': false,
        },
        props,
        cbs,
    })
}


export function infoMoal({ cbs, props,on }) {
    return new BaseDialog({
        component: ()=>import('./info'),
        options: {
            width: '75%',
            title: '操作详情',
            wrapperClosable: false,
            'close-on-click-modal': false,
            top: '100px'
        },
        props,
        cbs,
        on,
    })
}